import { useForm, FormProvider } from "react-hook-form";
import DatePicker from "components/v2/DatePicker/DatePicker";

type DateFilterProps = {
  currentFilters: Record<string, any>;
  setFilters: Function;
  filterKey: string;
  eventContext: string;
};

function DateFilter(props: DateFilterProps) {
  const { currentFilters, setFilters, filterKey } = props;
  const methods = useForm();

  return (
    <form>
      <FormProvider {...methods}>
        <DatePicker
          selectionMode="range"
          enableQuickSelection
          name={{ from: "from", to: "to" }}
          onDateSelect={(range) => {
            setFilters({
              ...currentFilters,
              [filterKey]: range,
            });
          }}
        />
      </FormProvider>
    </form>
  );
}

export default DateFilter;
